export const circle = `border-radius: 50%`;
export const defaultBoxShadow = `box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1)`;

const utils = {
  circle,
  defaultBoxShadow,
};

export default utils;
